import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, CardBody, Container, Modal, ModalBody, ModalFooter, ModalHeader, Table } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../../../../app/config/store';
import { PdfIcon } from '../../shared/icon-svg/icon';
import axios from 'axios';
import { toast } from 'react-toastify';
import Stepperform from '../../shared/layout/stepperform/stepperform';
import { useLocation, useNavigate } from 'react-router';
import FooterComponent from '../../shared/layout/footer/footer';
import AiGeneratedReport from './ai-generated-report';
import { ReviewCaseSkeleton } from '../../modules/case-questionaire/skeleton';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { getSubscription } from '../case-forms/case-lawyer.reducer';

export const CaseReview = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isDownload, setIsDownload] = useState<boolean>(false);
  const [fieldData, setFieldData] = useState<any>([]);
  const [finalScreen, setFinalScreen] = useState<any>([]);
  const [getId, setId] = useState<any>();
  const get_ai_id: any = localStorage.getItem('ai_id');
  const initalAiId = JSON.parse(get_ai_id);
  const [loader, setLoader] = useState<boolean>(false);
  const reportRef: any = useRef(null);
  const location = useLocation();
  const timeoutRef = useRef<any>(null);
  const [planAmount, setPlanAmount] = useState<any>(0);
  const [reportName, setReportName] = useState<any>('');
  const navigate = useNavigate();
  const { id } = useAppSelector(state => state.authentication?.account);

  useEffect(() => {
    const viewReport = async () => {
      const plan = await getSubscription(id);
      plan?.amountPaid && setPlanAmount(plan?.amountPaid || 0);
    };
    viewReport();
  }, []);

  useEffect(() => {
    if (showModal) {
      const firstText = getReportName();
      setReportName(firstText);
    }
  }, [showModal]);

  const handleEdit = () => {
    navigate('/step-1');
  };

  const getReportName = () => {
    const cleanHtml = sanitizeHtmlForPDF(finalScreen);
    const cleanHtmld = stripBom(cleanHtml.trimStart());
    const parser = new DOMParser();
    const doc = parser?.parseFromString(cleanHtmld, 'text/html');
    const firstNode: Element | null = doc?.body?.firstElementChild;
    const firstText: string | any = firstNode ? firstNode?.textContent?.trim() : null;
    return firstText;
  };

  const getDocumentData = async (id: any) => {
    // const requestUrl = `api/workflows/${process.env.IS_DEV ? '4777' : '7911'}/start?extRefKey=${id}`;
    const requestUrl = `api/workflows/7911/start?extRefKey=${id}`;

    try {
      const response = await axios.get(requestUrl, {
        headers: {
          'Content-Type': 'application/json',
          'Workflow-Authorization': 'Dyhac$25!',
        },
      });
      if (response.status == 200) {
        setId(response.data?.data);
        getUserFields(response.data?.data);
      }
    } catch (error) {
      setLoader(false);
      toast.error('Something went wrong', {
        position: 'top-right',
      });
    }
  };

  useEffect(() => {
    if (location.pathname === '/report') {
      getDocumentData(id);
      setLoader(true);
    }

    return () => {
      stopPolling();
    };
  }, [location.pathname, id]);

  useEffect(() => {
    if (fieldData && fieldData.length > 0) {
      setTimeout(() => {
        getTwoScreen(getId);
      }, 1000);
    }
  }, [fieldData, getId]);

  const getTwoScreen = async id => {
    const requestUrl = `/api/workflows/step/${getId}?stepNum=0`;
    try {
      const response = await axios.post(requestUrl, fieldData, {
        headers: {
          'Content-Type': 'application/json',
          'Workflow-Authorization': 'Dyhac$25!',
        },
      });

      if (response.status == 200) {
        getUploadedDocument();
      }
    } catch (error) {
      setLoader(false);
      toast.error('Something went wrong', {
        position: 'top-right',
      });
    }
  };

  function stripBom(html: string) {
    return html.replace(/^\uFEFF/, '');
  }

  const formatDate = (value: string) => {
    const parsed = Date.parse(value);
    return !isNaN(parsed)
      ? new Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }).format(new Date(parsed))
      : value;
  };

  // function sanitizeHtmlForPDF(finalScreen: string): string {
  //   if (!finalScreen) return '';

  //   const seenLabelValue = new Set<string>();

  //   const htmlStartIndex = finalScreen.indexOf('Date:');
  //   const plainTextPart = htmlStartIndex !== -1 ? finalScreen.slice(0, htmlStartIndex).trim() : finalScreen;
  //   const htmlPart = htmlStartIndex !== -1 ? finalScreen.slice(htmlStartIndex) : '';

  //   let cleanedHtml = htmlPart
  //     .replace(/<\s*\/?\s*(html|head|title|style|body|meta|link|script)[^>]*>/gi, '')
  //     .replace(/<!DOCTYPE[^>]*>/gi, '')
  //     .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
  //     .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
  //     .replace(/\s*style="[^"]*"/gi, '')
  //     .trim();

  //   const fieldHtmlBlocks: string[] = [];
  //   const evidenceDetails: string[] = [];

  //   let firstIncidentDate = '';
  //   let latestIncidentDate = '';
  //   let discriminationType = '';
  //   const dateLabels = ['Date of the 1st incident', 'Date of latest incident', 'Date of the first incident', 'Date of incident', 'Date'];

  //   const lines = plainTextPart.split('\n').filter(line => line.trim());
  //   lines.forEach(rawLine => {
  //     const cleanText = rawLine
  //       .replace(/<[^>]+>/g, '')
  //       .replace(/[*#]/g, '')
  //       .trim();
  //     const lower = cleanText.toLowerCase();
  //     if (!cleanText || lower === 'null') return;
  //     if (rawLine.trim().startsWith('**') && rawLine.trim().endsWith('**')) {
  //       const headingText = rawLine.replace(/\*/g, '').trim();
  //       fieldHtmlBlocks.push(`
  //       <h2 style="font-size:1.3rem;font-weight:bold;margin-top:1em;color:#111;">
  //         ${headingText}
  //       </h2>
  //     `);
  //       return;
  //     }

  //     if (lower.startsWith('type of discrimination')) {
  //       discriminationType = cleanText.split(':')[1]?.trim() || '';
  //     } else if (lower.startsWith('date of the 1st incident')) {
  //       firstIncidentDate = cleanText.split(':')[1]?.trim() || '';
  //     } else if (lower.startsWith('date of latest incident')) {
  //       latestIncidentDate = cleanText.split(':')[1]?.trim() || '';
  //     }

  //     if (cleanText.includes(':') && !cleanText.startsWith('-')) {
  //       const [label, ...rest] = cleanText.split(':');
  //       const rawValue = rest.join(':').trim();
  //       const key = `${label.trim()}:${rawValue}`;
  //       if (!rawValue || seenLabelValue.has(key)) return;

  //       seenLabelValue.add(key);
  //       const formattedLabel = label.trim();
  //       let formattedValue = rawValue;

  //       if (dateLabels.some(dl => formattedLabel.toLowerCase().includes(dl.toLowerCase()))) {
  //         formattedValue = formatDate(formattedValue);
  //       }

  //       const fieldBlock = `
  //       <div style="margin-bottom:10px;">
  //         <div style="font-weight:bold;margin-bottom:4px;color:#222;">${formattedLabel}</div>
  //         <div>${formattedValue}</div>
  //       </div>
  //     `;
  //       fieldHtmlBlocks.push(fieldBlock);
  //     }
  //   });

  //   const headerHtml = `
  //   <h1 style="font-size:1.8rem;font-weight:bold;color:#222;text-align:center;">
  //     ${discriminationType || 'Discrimination'} Report
  //   </h1>
  //   ${
  //     firstIncidentDate && latestIncidentDate
  //       ? `<p style="text-align:center;margin-bottom:1em;font-size:0.95rem;">
  //           Dates: ${formatDate(firstIncidentDate)} to ${formatDate(latestIncidentDate)}
  //         </p>`
  //       : ''
  //   }
  // `;

  //   const cleanData = htmlPart.split('\n').filter(line => line.trim());
  //   cleanData.forEach((rawLine, ind) => {
  //     const cleanText = rawLine
  //       .replace(/<[^>]+>/g, '')
  //       .replace(/[*#]/g, '')
  //       .trim();
  //     const lower = cleanText.toLowerCase();

  //     if (!cleanText || lower === 'null') return;

  //     const isHeading = rawLine.trim().startsWith('**') && rawLine.trim().endsWith('**');
  //     if (isHeading) {
  //       const headingText = rawLine.replace(/\*/g, '').trim();
  //       evidenceDetails.push(`
  //       <h2 style="font-size:1.3rem;font-weight:bold;margin-top:1em;color:#111;">
  //         ${headingText}
  //       </h2>
  //     `);
  //     } else if (['Conclusion', 'Key Points', 'Collected Evidence'].includes(rawLine.trim())) {
  //       const headings = ` <h4 style="font-size:1.3rem;font-weight:bold;margin-top:1em;color:#111;">
  //           ${rawLine.replace(/[*#]/g, '').trim()}
  //         </h4>`;
  //       evidenceDetails.push(headings);
  //     } else {
  //       const paragraphTag = `
  //     <p style="font-size:0.95rem;">
  //       ${rawLine.replace(/^[\s*#-]+/, '').trim()}
  //     </p>`;
  //       evidenceDetails.push(paragraphTag);
  //     }
  //   });

  //   return `
  //   ${headerHtml}
  //   ${fieldHtmlBlocks.join('\n')}
  //   ${evidenceDetails.join('\n')}
  // `.trim();
  // }

  function sanitizeHtmlForPDF(finalScreen: string): string {
    if (!finalScreen) return '';
    const seenLabelValue = new Set<string>();
    const evidenceStartPattern = /\n\n\n\s*Date:/;
    const evidenceStartIndex = finalScreen.search(evidenceStartPattern);
    const plainTextPart = evidenceStartIndex !== -1 ? finalScreen.slice(0, evidenceStartIndex).trim() : finalScreen;
    const evidencePart = evidenceStartIndex !== -1 ? finalScreen.slice(evidenceStartIndex).trim() : '';

    const fieldHtmlBlocks: string[] = [];
    const evidenceDetails: string[] = [];
    const customEvidenceBlock = `
    <h3 class="evidence-heading">
      Collected Evidence
    </h3>
  `;

    let firstIncidentDate = '';
    let latestIncidentDate = '';
    let discriminationType = '';
    const dateLabels = ['Date of the 1st incident', 'Date of latest incident', 'Date of the first incident', 'Date of incident', 'Date'];
    let questionNumber = 1;
    const lines = plainTextPart.split('\n').filter(line => line.trim());
    lines.forEach(rawLine => {
      const cleanText = rawLine
        .replace(/<[^>]+>/g, '')
        .replace(/[*#]/g, '')
        .trim();
      const lower = cleanText.toLowerCase();
      if (!cleanText || lower === 'null') return;

      if (rawLine.trim().startsWith('**') && rawLine.trim().endsWith('**')) {
        const headingText = rawLine
          .replace(/```[a-zA-Z]*[\s\S]*?```/g, '')
          .replace(/\*/g, '')
          .trim();
        fieldHtmlBlocks.push(`<h2 style="font-size:1.3rem;font-weight:bold;margin-top:1em;color:#111;">${headingText}</h2>`);
        return;
      }

      if (lower.startsWith('type of discrimination')) {
        discriminationType = cleanText.split(':(:ans:)')[1]?.trim() || '';
      } else if (lower.startsWith('date of the 1st incident')) {
        firstIncidentDate = cleanText.split(':(:ans:)')[1]?.trim() || '';
      } else if (lower.startsWith('date of latest incident')) {
        latestIncidentDate = cleanText.split(':(:ans:)')[1]?.trim() || '';
      }

      if (cleanText.includes(':') && !cleanText.startsWith('-')) {
        const [label, ...rest] = cleanText.split(':(:ans:)');
        const rawValue = rest.join(':').trim();
        const key = `${label.trim()}:${rawValue}`;
        if (!rawValue || seenLabelValue.has(key)) return;

        seenLabelValue.add(key);
        const formattedLabel = label.trim();
        let formattedValue = rawValue;

        if (dateLabels.some(dl => formattedLabel.toLowerCase().includes(dl.toLowerCase()))) {
          formattedValue = formatDate(formattedValue);
        }

        const fieldBlock = `
      <div class="field-block">
      <div class="field-row">
   <div class="field-number">${questionNumber}.</div>
    <div class="field-content">
      <div class="field-label">${formattedLabel}</div>
      <div class="field-answer">${formattedValue}</div>
    </div>
     </div>
</div>
      `;
        fieldHtmlBlocks.push(fieldBlock);
        questionNumber++;
      }
    });

    if (evidencePart.startsWith('Date:')) {
      const evidenceBlocks = evidencePart.split(/\n(?=Date:)/).filter(block => block.trim());
      evidenceDetails.push(customEvidenceBlock);
      let exhibit = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ];
      let exhibitIndex = 0;
      evidenceBlocks.forEach(block => {
        const currentEvidence: { [key: string]: string | boolean } = {};
        const relevanceMatch = block.match(/Relevance:\s*([\s\S]*?)(?=(?:\nFile Type:|\nFile Name:|$))/); //remove date
        if (relevanceMatch) {
          let relevanceText = relevanceMatch[1].trim();

          if (relevanceText) {
            const lines = relevanceText
              .split(/\n+/)
              .map(l => l.trim())
              .filter(Boolean);

            if (lines.length === 1) {
              relevanceText = lines[0];
              currentEvidence['RelevanceInline'] = true;
            } else {
              relevanceText = lines.join('<br/>');
              currentEvidence['RelevanceInline'] = false;
            }
          }

          currentEvidence['Relevance'] = relevanceText;
          const dateMatch = block.match(/Date:\s*([^\n]+)/);
          const typeMatch = block.match(/File Type:\s*([^\n]+)/);
          const fileNameMatch = block.match(/File Name:\s*([^\n]+)/);

          if (dateMatch) currentEvidence['Date'] = dateMatch[1].trim();
          if (typeMatch) currentEvidence['File Type'] = typeMatch[1].trim();
          if (fileNameMatch) currentEvidence['File Name'] = fileNameMatch[1].trim();
          evidenceDetails.push(`
        <h4 style="margin-top:20px;color:#111;">Exhibit ${exhibit[exhibitIndex]}</h4>
        <div style="
          display:flex;
          flex-wrap:wrap;
          gap:10px;
          align-items:flex-start;
          padding:8px 12px;
          border-bottom:1px solid #ddd;
        ">
          <div style="flex:1 1 150px; min-width:150px;">
            <strong>Date:</strong> ${currentEvidence['Date'] || ''}
          </div>
          <div style="flex:1 1 200px; min-width:150px;">
            <strong>Relevance:</strong>
            ${currentEvidence['RelevanceInline'] ? ' ' : '<br/>'}
            ${currentEvidence['Relevance'] || ''}
          </div>
          <div style="flex:1 1 120px; min-width:120px;">
            <strong>File Type:</strong> ${currentEvidence['File Type'] || ''}
          </div>
          <div style="flex:2 1 250px; min-width:180px; word-break:break-word;">
            <strong>File Name:</strong> ${currentEvidence['File Name'] || ''}
          </div>
        </div>
      `);

          exhibitIndex++;
        }
      });
    }

    const headerHtml = `
    <h1 style="font-size:1.8rem;font-weight:bold;color:#222;text-align:center;">
      ${discriminationType || 'Discrimination'} Report
    </h1>
    ${
      firstIncidentDate && latestIncidentDate
        ? `<p style="text-align:center;margin-bottom:1em;font-size:0.95rem;">
            Dates: ${formatDate(firstIncidentDate)} to ${formatDate(latestIncidentDate)}
          </p>`
        : ' <p style="text-align:center;margin-bottom:2em;font-size:0.95rem;"></p>'
    }
  `;
    return `
    ${headerHtml}
    ${fieldHtmlBlocks.join('\n')}
    ${evidenceDetails.join('\n')}
  `.trim();
  }
  console.log('checking');
  const downloadFromBackend = async () => {
    const cleanHtml = sanitizeHtmlForPDF(finalScreen);

    const cleanHtmld = stripBom(cleanHtml.trimStart());
    const firstText = getReportName();

    try {
      const res = await axios.post(
        'api/generate-pdf',
        { content: cleanHtmld },
        {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${firstText ? firstText : 'dyhac'}_report.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error('PDF download failed:', {
        position: 'top-right',
      });
    }
  };

  const getUploadedDocument = async () => {
    const requestUrl = `api/generate-document-v3`;
    const payload = {
      documentDesc:
        'Create a detailed summary of my legal evidence information based solely on the information I provide. The summary should be written in natural, human language. Do not use Markdown syntax, backticks, or special characters like asterisks. Maintain a clean and professional layout with clear section headers and consistent formatting throughout.',
      fileUseType: 'GENERATED_DOCUMENT',
      aiAssistantId: 7911,
      fileMetaDataAiAssistantId: 6491,
      aiChatId: getId,
      extRefKey: id,
    };
    try {
      const response = await axios.post(requestUrl, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Workflow-Authorization': 'Dyhac$25!',
        },
      });
      response?.data?.id && pollFinalReview(response?.data?.id);
    } catch (error) {
      setLoader(false);
      setFinalScreen([]);
      toast.error('Something went wrong', {
        position: 'top-right',
      });
    }
  };

  const getFinalReview = async aiId => {
    try {
      const requestUrl = `api/upload-file/${aiId}`;
      const response = await axios.get(requestUrl, {
        headers: {
          'Content-Type': 'application/json',
          'Workflow-Authorization': 'Dyhac$25!',
        },
      });

      if (response.status === 200) {
        const content = response?.data?.content;
        try {
          const parsedContent = JSON.parse(content);
          if (parsedContent?.message === 'File Not Found') {
            setLoader(false);
          } else {
            setFinalScreen(content);
          }
        } catch (parseErr) {
          setFinalScreen(content);
        }
      }
    } catch (error) {
      toast.error('Something went wrong', {
        position: 'top-right',
      });
    } finally {
      setLoader(false);
    }
  };

  const pollFinalReview = (aiId, interval = 12000, maxAttempts = 20) => {
    let attempts = 0;
    const getReport = async () => {
      try {
        const requestUrl = `api/file-upload/v2/${aiId}`;
        const response = await axios.get(requestUrl, {
          headers: {
            'Content-Type': 'application/json',
            'Workflow-Authorization': 'Dyhac$25!',
          },
        });

        if (response?.data?.status !== 'STARTED') {
          response?.data?.id && getFinalReview(response?.data?.id);
          return;
        }
        attempts++;
        if (attempts < maxAttempts) {
          timeoutRef.current = setTimeout(getReport, interval);
        } else {
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
        toast.error('Something went wrong', {
          position: 'top-right',
        });
      }
    };
    setLoader(true);

    if (location.pathname == '/report') {
      getReport();
    } else {
      stopPolling();
      return;
    }
  };

  const stopPolling = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const getUserFields = async id => {
    const requestUrl = `api/user-profile-fields/${initalAiId}`;
    try {
      const response = await axios.get(requestUrl, {
        headers: {
          'Content-Type': 'application/json',
          'Workflow-Authorization': 'Dyhac$25!',
        },
      });
      if (response.status == 200 && response.data?.length > 0) {
        setFieldData(response.data);
      } else {
        setLoader(false);
        setFinalScreen([]);
      }
    } catch (error) {
      setLoader(false);
      toast.error('Something went wrong', {
        position: 'top-right',
      });
    }
  };
  const handleConfirm = () => {
    setShowModal(true);
    const currentStep = 4;
    if (!id) {
      return;
    }
    const submittedStr = localStorage.getItem('submittedstep');
    const submitted = submittedStr ? JSON.parse(submittedStr) : {};

    const userSteps = submitted[id] || [];

    if (!userSteps.includes(currentStep)) {
      userSteps.push(currentStep);
      submitted[id] = userSteps;
      localStorage.setItem('submittedstep', JSON.stringify(submitted));
    }
  };

  // const handleDownloadPDF = async () => {
  //   setIsDownload(true);
  //   const input = reportRef.current;
  //   if (!input) return;
  //   await new Promise(resolve => requestAnimationFrame(resolve));

  //   const pdf = new jsPDF('p', 'mm', 'a4');
  //   const margin = 10;
  //   const pageWidth = pdf.internal.pageSize.getWidth();
  //   const pageHeight = pdf.internal.pageSize.getHeight();
  //   const usableWidth = pageWidth - margin * 2;

  //   const canvas = await html2canvas(input, {
  //     scale: 2,
  //     scrollY: -window.scrollY,
  //     useCORS: true,
  //     backgroundColor: '#fff',
  //     windowWidth: input.scrollWidth,
  //   });

  //   const imgData = canvas.toDataURL('image/png');
  //   const imgProps = pdf.getImageProperties(imgData);
  //   const imgHeight = (imgProps.height * usableWidth) / imgProps.width;

  //   let remainingHeight = imgHeight;
  //   let position = 0;

  //   while (remainingHeight > 0) {
  //     pdf.addImage(imgData, 'PNG', margin, position - (imgHeight - remainingHeight), usableWidth, imgHeight);
  //     remainingHeight -= pageHeight;
  //     if (remainingHeight > 0) pdf.addPage();
  //   }

  //   pdf.save('AI-Generated-Report.pdf');
  //   setIsDownload(false);
  // };

  const handleDownloadPDF = async () => {
    setIsDownload(true);
    const input = reportRef.current;
    if (!input) return;

    const topMargin = 30;
    const bottomMargin = 30;

    const clone = input.cloneNode(true) as HTMLElement;
    clone.style.position = 'absolute';
    clone.style.left = '-9999px';
    clone.style.top = '0';
    document.body.appendChild(clone);

    try {
      const canvas = await html2canvas(clone, {
        scale: 2,
        useCORS: true,
        scrollY: -window.scrollY,
      });

      const pdf = new jsPDF('p', 'pt', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const scaleRatio = pdfWidth / canvasWidth;

      const usablePdfHeight = pdfHeight - topMargin - bottomMargin;
      const pageHeightPx = usablePdfHeight / scaleRatio;

      let position = 0;
      const totalPages = Math.ceil(canvasHeight / pageHeightPx);

      for (let page = 0; page < totalPages; page++) {
        if (page > 0) pdf.addPage();

        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvasWidth;
        const actualPageHeight = Math.min(pageHeightPx, canvasHeight - position);
        pageCanvas.height = actualPageHeight;

        const ctx = pageCanvas.getContext('2d');
        if (ctx) {
          ctx.fillStyle = '#fff';
          ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
          ctx.drawImage(canvas, 0, position, canvasWidth, actualPageHeight, 0, 0, canvasWidth, actualPageHeight);
        }

        const imgData = pageCanvas.toDataURL('image/png');
        const imgHeightPt = actualPageHeight * scaleRatio;

        pdf.addImage(imgData, 'PNG', 0, topMargin, pdfWidth, imgHeightPt);

        position += pageHeightPx;
      }

      pdf.save('ai_generated_report.pdf');
    } catch (err) {
      console.error('PDF generation error:', err);
    } finally {
      document.body.removeChild(clone);
      setIsDownload(false);
    }
  };

  const handleDownloadPDFf = async () => {
    const input = reportRef.current;
    if (!input) return;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgWidth = 220;
    const pageHeight = 300;
    const marginLeft = 10;
    const marginTop = 20;
    const pdf = new jsPDF('p', 'mm', 'a4');
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const ratio = imgWidth / canvasWidth;
    const imgHeight = canvasHeight * ratio;
    const pageCanvasHeight = (pageHeight - marginTop * 2) / ratio;
    let renderedHeight = 0;
    const pageCanvas = document.createElement('canvas');
    pageCanvas.width = canvas.width;
    pageCanvas.height = pageCanvasHeight;
    const pageCtx: any = pageCanvas.getContext('2d');
    let pageIndex = 0;
    while (renderedHeight < canvasHeight) {
      pageCtx.clearRect(0, 0, canvas.width, pageCanvasHeight);
      // Draw current slice of canvas onto pageCanvas
      pageCtx.drawImage(canvas, 0, renderedHeight, canvas.width, pageCanvasHeight, 0, 0, canvas.width, pageCanvasHeight);
      const imgData = pageCanvas.toDataURL('image/png');
      if (pageIndex > 0) pdf.addPage();
      pdf.addImage(imgData, 'PNG', marginLeft, marginTop, imgWidth - marginLeft * 2, pageHeight - marginTop * 3);
      renderedHeight += pageCanvasHeight;
      pageIndex++;
    }
    pdf.save('AI-Generated-Report.pdf');
  };

  return (
    <>
      <div className="main-content flex-grow-1 d-flex flex-column gap-5 justify-content-between px-4 pb-4">
        <div className="custom-container flex-grow-1">
          <h1 className="page-title">Case Details Form</h1>
          <Stepperform />
          <Card className="card-wrapper">
            <Modal isOpen={showModal} toggle={() => setShowModal(!showModal)} centered className="custom-modal download-pop-up">
              <ModalHeader>Case Assessment Summary File</ModalHeader>
              <ModalBody className="flex-wrap justify-content-start align-items-center gap-12 ">
                <div className="p-3 border rounded download-body d-flex align-items-start gap-2">
                  <PdfIcon />
                  <div className="d-flex flex-column gap-1">
                    <h6 className="mb-0">{reportName}.PDF</h6>
                    {/* <p className="text-muted mb-0">200 KB</p> */}
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                {/* {planAmount == 0 && ( */}
                <Button className="download-button" onClick={() => downloadFromBackend()}>
                  {isDownload ? 'Downloading...' : 'Click to Download'}
                </Button>
                {/* )} */}
              </ModalFooter>
            </Modal>

            <div className="scrollable-content mb-3">
              <h3 className="form-title">Review Case Report</h3>
              <p> Respond to the questions ,Revise and rerurn when you have updates, upload evidence and review.</p>

              {loader && (
                <div className="d-flex justify-content-between">
                  <p>
                    <strong>Please wait, Document is generating ......</strong>
                  </p>
                </div>
              )}
              <div>
                {loader && <ReviewCaseSkeleton />}
                {finalScreen?.length > 0 && <AiGeneratedReport finalScreen={finalScreen} />}
              </div>
              {finalScreen?.length == 0 && !loader && (
                <div className="text-center  mt-3 fw-bold">
                  We were unable to generate your report due to a system error.
                  <br />
                  Please try again later or contact support if the issue continues.
                </div>
              )}
            </div>

            <div className="d-flex  gap-3 mt-4 mt-3">
              <Button className="theme-button" onClick={() => handleConfirm()} disabled={finalScreen?.length > 0 ? false : true}>
                Confirm
              </Button>

              <Button className="theme-button-dark" disabled={loader} onClick={() => handleEdit()}>
                Edit
              </Button>
            </div>
          </Card>
        </div>
        <FooterComponent />
      </div>
    </>
  );
};

export default CaseReview;
